class ProductReviewGrid extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-product-review-card]'));
    this.button = this.querySelector('[data-product-review-more]');
    this.initialVisible = Number(this.dataset.initialVisible) || 6;
    this.batchSize = Number(this.dataset.batchSize) || 4;
    this.visibleCount = Math.min(this.initialVisible, this.cards.length);

    this.cards.forEach((card, index) => {
      card.hidden = index >= this.visibleCount;
    });

    this.button?.addEventListener('click', () => this.showMore());
    this.updateButton();
  }

  showMore() {
    const nextVisibleCount = Math.min(this.visibleCount + this.batchSize, this.cards.length);

    this.cards.slice(this.visibleCount, nextVisibleCount).forEach((card) => {
      card.hidden = false;
    });

    this.visibleCount = nextVisibleCount;
    this.updateButton();
  }

  updateButton() {
    if (!this.button) return;

    const hasMore = this.visibleCount < this.cards.length;
    this.button.hidden = !hasMore;
    this.button.setAttribute('aria-expanded', String(!hasMore));
  }
}

if (!customElements.get('product-review-grid')) {
  customElements.define('product-review-grid', ProductReviewGrid);
}
